import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we do</h2>
          <h5 className={classes.description}>
            Kinos provides services to commercial and residential real estate users, owners, tenants, investors and developers; they include brokerage, marketing and sales, consulting, services to family offices, investment services, landlord and tenant representation, project management, urban planning, property and asset management, valuation and advisory services.
          </h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="SELLING AND BUYING
BROKERAGE"
            description={
              <span>
                <p>
                  <h5>Kinos real estate brokerage services  bring a lot to the table.</h5>
                  <h5>
                    Kinos work to provide the best return on investment to clients looking to sell or lease out properties.
                  </h5>
                  <h5>
                    We assist investors in identifying properties for purchase or lease that are most suitable to their situation and goals.
                  </h5>
                  <h5>
                    Kinos connect investors with creative financing options that fit very specific needs, and structure transactions that minimize tax costs and maximize tax benefits.
                    We also offer additional services, like property, project and portfolio management, property appraisal and development, and business consulting.{" "}
                  </h5>
                </p>
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="FAMILY  OFFICES
SERVICES"
            description={
              <span>
                <p>
                  <h5>
                  An institutional approach for managing family wealth across generations.
Kinos Family Office offers end-to-end advisory services for families and organizations on their assets (financial, property, projects and company holdings), with a view to preserving their wealth over time and with a global, independent approach.
Managing and nurturing family wealth
* Family Office Mandate for advisory services on all client assets.
* Consultancy projects for strategic planning of family assets.
* Advice and support on creating a Single Family Office.
Evaluation of family assets.
PROMOTING FAMILY BUSINESSES. Awarding excellence
{" "}
                  </h5>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="NEW DEVELOPMETS
MARKETING AND SALES"
            description={
              <span>
                <p>
                  <h5>
                  This unique new homes consultancy service provides property developers with a dedicated team with in-depth knowledge, arguably unrivalled by other real estate marketing companies.
We are poised to redefine the industry with more robust services, markets, and systems for the betterment of clients. Specialized service models are offered for every product type, from single-family up to large, mixed-use, masterplan communities, while adherence to a structured development lifecycle ensures project success from beginning to end.
{" "}
                  </h5>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="ASSET MANAGEMENT "
            description={
              <span>
                <p>
                  <h5>
                  Portfolio management demands knowledge of the property market, understanding of the needs and financial requirements of investors, expectations of tenants and expertise of the building's technology and structure. With our extensive market knowledge gathered from all properties analyzed in the complimentary service lines, Kinos possesses in-house expertise for all real estate matters. By investors in Spain and across the globe we are seen as one of the most effective portfolio advisors. This reputation gives us a strong credibility in all lifecycle processes of the properties and portfolios to landlords.{" "}
                  </h5>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
